const routes = [
  {
    path: '/freelancer',
    component: () => import('../../twoRole/layout/FreelancerShell'),

    children: [
      {
        name: 'freelancer.dashboard',
        path: '',

        component: () => import('../../twoRole/pages/ProviderOverview'),
      },
      {
        name: 'freelancer.project',
        path: 'projects',
        // component: () => import('../../Seller/SellerProfile/EditProfile'),
        component: () => import('../freelancer/project/StandardProject/MainPage'),
      },
      {
        name: 'freelancer.project.details',
        path: 'projects/:project_slug/info',
        component: () => import('../freelancer/project/ProjectDetails'),
      },
      {
        path: 'profile',
        component: () => import('../freelancer/Profile/new_mainprofile.vue'),
        name: 'freelancer.profile',
      },

      {
        name: 'freelancer.profile.completed',
        path: 'profile/completed',
        component: () => import('../freelancer/Profile/profileCompleted.vue'),
      },

      // {
      //   name: 'freelancer.project.bid',
      //   path: 'projects/:project_slug/bid/:type?',
      //   component: () => import('../freelancer/project/submitBidForm'),
      // },
      {
        name: 'freelancer.project.bid.details',
        path: 'projects/:project_slug/bid/details',
        component: () => import('../freelancer/project/bidDetails'),
      },
      {
        name: 'freelancer.project.bid',
        path: 'projects/:project_slug/bid/:type?',
        component: () => import('../freelancer/project/submitBidForm'),
      },

      {
        name: 'freelancer.hired.project.details',
        path: 'projects/:project_slug/hired/details',
        component: () => import('../freelancer/project/HiredTab/HiredDetails'),
      },

      // browser and Buy
      {
        name: 'freelancer.browseAndBuy',
        path: 'browser-and-buy',
        redirect: '/freelancer/projects',
      },
      {
        name: 'freelancer.browseAndBuy.preview',
        path: 'browser-and-buy/:proposal_slug/preview',
        redirect: '/freelancer/projects',
      },
      {
        name: 'freelancer.browseAndBuy.create',
        path: 'browser-and-buy/create',
        redirect: '/freelancer/training_classes',
      },
      {
        name: 'freelancer.browseAndBuy.edit',
        path: 'browser-and-buy/edit/:proposal_slug',
        redirect: '/freelancer/projects',
      },
      {
        name: 'freelancer.browseAndBuy.draft',
        path: 'browser-and-buy-draft',
        redirect: '/freelancer/projects',
      },

      // ticket
      {
        name: 'freelancer.ticket.report',
        path: 'ticket-report',
        component: () => import('../freelancer/tickets/support_report'),
      },
      // ----Report------//
      {
        name: 'freelancer.reportOrder',
        path: 'order',
        component: () => import('../freelancer/Report/order'),
      },
      {
        name: 'freelancer.reportRevenue',
        path: 'revenue',
        component: () => import('../freelancer/Report/revenue'),
      },

      {
        path: 'chat',
        name: 'freelancer.chat',
        component: () => import('../templates/chatBox'),
      },
      {
        name: 'freelancer.accountdisable',
        path: 'account',
        component: () => import('../freelancer/account/account'),
      },

      ///training start

      {
        path: 'add_class',
        component: () => import('../../Training/Teacher/addClass'),
        name: 'AddClass',
      },
      {
        path: 'training_classes',
        component: () => import('../../Training/Teacher/training_classes'),
        name: 'TrainingClasses',
      },
      {
        path: 'training/class/edit/:id/:userId',
        component: () => import('../../Training/Teacher/addClass'),
        name: 'EditClass',
      },
      {
        path: 'viewReview',
        component: () => import('../../Training/Teacher/courseReviews'),
        name: 'ViewCourseReview',
      },
      {
        path: 'enrolledStudents',
        component: () => import('../../Training/Teacher/enrolledStudent'),
        name: 'EnrolledStudents',
      },
      {
        path: 'myclass',
        component: () => import('../../Training/MyClass/myclass'),
        name: 'MyClass',
      },

      {
        path: 'browseclass',
        component: () => import('../../Training/BrowseClass/browseclass'),
        name: 'BrowseClass',
      },
      {
        path: 'subscriptionPacks',
        component: () => import('../../Training/Subscription/subscription_pack'),
        name: 'SubscriptionPacks',
      },
      {
        name: 'freelancer.account',
        path: 'account_report',
        component: () => import('../freelancer/accountReport/report.vue'),
      },

      //training end
    ],
  },
];
export default routes;
